import styles from "./styles.module.scss";
import parse from "html-react-parser";
import Image from "next/image";
import Link from "next/link";

interface Urls {
  excerpt: string;
  content?: string;
  id: number;
  link: string;
  image: string;
  title?: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

export const Slide = ({ title, excerpt, image, link, id, onClick }: Urls) => {
  const excerptHTML = parse(excerpt);

  return (
    <Link data-id={id} href={link} className={styles.items} onClick={onClick}>
      <span className={[styles.animated, styles.fadeInUp].join(" ")}>
        <h2>{title}</h2>
        {excerptHTML}
      </span>

      <Image
        fill
        className={styles.image}
        placeholder="blur"
        blurDataURL="/static-next/placeholder-image.png"
        src={image}
        alt={title}
        title={title}
      />
    </Link>
  );
};
